import { Operator } from './operator';

export class EqualTo implements Operator {
	public evaluate(value: number, target: number): boolean {
		return value === target;
	}
}
